export const progressBarStyle: React.CSSProperties = { width: 350, paddingTop: 3 };
